// extracted by mini-css-extract-plugin
module.exports = {"growl":"Growl_growl__1r1AK","slidein":"Growl_slidein__1RkHS"};